import { Modal, Image, Text } from "@mantine/core";
import * as React from "react";

interface ImageModalProps {
  opened: boolean;
  onClose: () => void;
  imageSrc: string;
  caption?: string;
}

export function ImageModal({ opened, onClose, imageSrc, caption }: ImageModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="auto"
      centered
      padding={0}
      radius={0}
      withCloseButton
      styles={{
        inner: {
          padding: 0,
        },
        content: {
          background: 'white',
        },
        header: {
          position: 'absolute',
          right: 0,
          zIndex: 2,
          margin: 0,
          padding: 8,
          background: 'none',
        },
        close: {
          color: '#e27130',
          '&:hover': {
            // background: 'none',
          }
        },
        body: {
          padding: 0,
          margin: 0,
        }
      }}
      closeButtonProps={{
        "aria-label": "Close modal",
        size: "lg",
      }}
    >
      <div style={{ height: '90vh', display: 'flex', alignItems: 'center' }}>
        <Image
          src={imageSrc}
          fit="contain"
          height="90vh"
          withPlaceholder
        />
        {caption && (
          <Text 
            c="dimmed" 
            ta="center" 
            fs="italic"
            size="sm"
            py="xs"
            pos="absolute"
            bottom={0}
            left={0}
            right={0}
            bg="rgba(0, 0, 0, 0.03)"
          >
            {caption}
          </Text>
        )}
      </div>
    </Modal>
  );
} 